import axios from 'axios';
import store from '../store/';
import Vue from 'vue';
const REFRESH_TOKEN_URL = '/uac/auth/user/refreshToken';
export function refreshToken() {
    return axios({
        method: 'GET',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        url: REFRESH_TOKEN_URL,
        auth: {
            username: 'paascloud-client-uac',
            password: 'paascloudClientSecret'
        },
        params: {
            refreshToken: store.getters.getRefreshToken,
            accessToken: store.getters.getAccessToken
        }
    });
}
export function getUserInfo(token) {
    return Vue.prototype.$http({
        method: 'post',
        headers: {
            'deviceId': new Date().getTime(),
            "Authorization": 'Bearer ' + token
        },
        url: 'uac/user/getInformation',
    });
}
export function loginOut(token) {
    return Vue.prototype.$http({
        method: 'post',
        headers: {
            'deviceId': new Date().getTime(),
            "Authorization": 'Bearer ' + token
        },
        url: '/uac/user/logout',
        data: { 'accessToken': token }
    });
}


// WEBPACK FOOTER //
// ./src/api/index.js